import React, { useEffect, useState } from "react";

const Bill = ({ cartItems }) => {
  const [amount, setAmount] = useState(0);
  const [discount, setDiscount] = useState(0);

  const findAmount = () => {
    let amount = 0,
      discount = 0;
    cartItems.map((cartItem) => {
      amount += cartItem.price.mrp;
      discount += cartItem.price.mrp - cartItem.price.cost;
    });
    setAmount(amount);
    setDiscount(discount);
  };
  useEffect(() => {
    findAmount();
  }, [cartItems]);
  return (
    <>
      <div className="flex flex-col my-[20px] ml-[-30px] bg-slate-100 h-[400px] px-[12px] justify-center rounded-sm shadow-lg">
        <div className="text-[30px] mb-[20px] py-[30px] mx-[12px] underline flex justify-center mx-auto md:text-[40px] ">
          TOTAL BILL DETAILS
        </div>
        <div className="flex flex-col space-y-4 ">
          <div className="text-[20px] flex justify-between">
            <span>Price ({cartItems?.length} items):</span>
            <span> ₹{amount}</span>{" "}
          </div>
          <div className="text-[20px] flex justify-between">
            <span> Discount :</span>
            <span className="text-right text-red-500">-₹{discount}</span>
          </div>
          <div className="text-[20px] flex justify-between">
            <span>Delivery charges:</span>
            <span>₹50</span>
          </div>
          <hr />
          <div className="text-[25px] font-semibold flex justify-between">
            <span> Total amount :</span>
            <span className="text-green-500"> ₹{amount - discount}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Bill;
